<script>
	import { onMount } from "svelte";

	export let activeTab = "admin";
	export let onSelectTab = (tab) => {};
	export let activeOrdersCount = 0;
	export let isAuthenticated = false;
	export let isSubscriptionActive = true;
	export let storeName = "";
	export let currentUser = { name: "Proprietário", role: "owner" };
	export let whatsappStatus = "Desconectado";
	export let printerStatus = "Desconectada";
	export let onOpenSwitchUser = () => {};
	export let isOpenMobile = false;
	export let onCloseMobile = () => {};

	// Personalização de Foto de Perfil
	let userAvatar = "";
	try {
		userAvatar = localStorage.getItem("matafome_user_avatar") || "";
	} catch (e) {}

	let fileInputRef;
	let showProfileMenu = false;

	// Personalização do Logotipo da Loja / Estabelecimento
	let storeLogo = "";
	let storeLogoInputRef;
	try {
		storeLogo = localStorage.getItem("matafome_store_logo") || "";
	} catch (e) {}

	function syncStoreLogo() {
		try {
			storeLogo = localStorage.getItem("matafome_store_logo") || "";
		} catch (e) {}
	}

	onMount(() => {
		if (typeof window !== "undefined") {
			window.addEventListener("store-logo-changed", syncStoreLogo);
			return () => {
				window.removeEventListener("store-logo-changed", syncStoreLogo);
			};
		}
	});

	function triggerStoreLogoUpload() {
		if (storeLogoInputRef) storeLogoInputRef.click();
	}

	function handleStoreLogoUpload(e) {
		const file = e.target.files && e.target.files[0];
		if (!file) return;
		if (file.size > 4 * 1024 * 1024) {
			alert("A imagem selecionada é muito pesada (máximo 4MB).");
			return;
		}
		const reader = new FileReader();
		reader.onload = (ev) => {
			storeLogo = ev.target.result;
			try {
				localStorage.setItem("matafome_store_logo", storeLogo);
				window.dispatchEvent(new Event("store-logo-changed"));
			} catch (err) {}
		};
		reader.readAsDataURL(file);
	}

	function restoreDefaultStoreLogo() {
		storeLogo = "";
		try {
			localStorage.removeItem("matafome_store_logo");
			window.dispatchEvent(new Event("store-logo-changed"));
		} catch (err) {}
	}

	function triggerAvatarUpload() {
		if (fileInputRef) fileInputRef.click();
	}

	function handleAvatarUpload(e) {
		const file = e.target.files && e.target.files[0];
		if (!file) return;
		if (file.size > 4 * 1024 * 1024) {
			alert("A imagem selecionada é muito pesada (máximo 4MB).");
			return;
		}
		const reader = new FileReader();
		reader.onload = (ev) => {
			userAvatar = ev.target.result;
			try {
				localStorage.setItem("matafome_user_avatar", userAvatar);
			} catch (err) {}
		};
		reader.readAsDataURL(file);
	}

	function removeAvatar() {
		userAvatar = "";
		try {
			localStorage.removeItem("matafome_user_avatar");
		} catch (err) {}
	}

	function handleGlobalClick(e) {
		if (!e.target.closest(".profile-card-wrapper")) {
			showProfileMenu = false;
		}
	}

	function isTabAllowed(tab, role) {
		if (!role || role === 'owner') return true;
		if (role === 'waiter') {
			return tab === 'tables'; // Garçom tem foco total em Salão & Mesas
		}
		if (role === 'cashier') {
			// Caixa opera Kanban, Mesas, Entregadores, Controle de Caixa e Impressão (Relatórios/DRE é exclusivo do Dono)
			return ['kanban', 'tables', 'couriers', 'cashier', 'printer'].includes(tab);
		}
		return true;
	}

	function select(tab) {
		if (tab === "master") {
			if (onSelectTab) onSelectTab("master");
			return;
		}

		if (tab === "logout") {
			if (onSelectTab) onSelectTab("logout");
			return;
		}

		if (tab === "admin") {
			if (onSelectTab) onSelectTab("admin");
			return;
		}

		if (!isAuthenticated) {
			if (onSelectTab) onSelectTab("login_required");
			return;
		}

		if (!isSubscriptionActive && tab !== "settings") {
			if (onSelectTab) onSelectTab("subscription_blocked");
			return;
		}

		const userRole = currentUser?.role || 'owner';
		if (!isTabAllowed(tab, userRole)) {
			if (onSelectTab) onSelectTab("role_restricted_" + userRole);
			return;
		}

		if (onCloseMobile) onCloseMobile();
		if (onSelectTab) onSelectTab(tab);
	}
</script>

<svelte:window on:click={handleGlobalClick} />

{#if isOpenMobile}
	<!-- Backdrop para fechar Sidebar no mobile -->
	<div 
		class="sidebar-backdrop" 
		on:click={onCloseMobile}
		on:keydown={(e) => e.key === 'Escape' && onCloseMobile()}
	></div>
{/if}

<aside class="sidebar" class:mobile-open={isOpenMobile}>
	<!-- Input Invisível para Upload da Logo da Loja -->
	<input 
		type="file" 
		accept="image/png, image/jpeg, image/webp, image/svg+xml" 
		style="display:none;" 
		bind:this={storeLogoInputRef} 
		on:change={handleStoreLogoUpload} 
	/>

	<!-- 1. Header com Marca (Personalizável para a Loja, Redireciona para Kanban) -->
	<div class="brand-box" on:click={() => select("kanban")} title="Ir para Pedidos">
		<div 
			class="brand-avatar-box {storeLogo ? 'has-custom-logo' : ''}" 
			on:click|stopPropagation={triggerStoreLogoUpload} 
			title={storeLogo ? "Logotipo do Restaurante (Clique para trocar a imagem)" : "Logotipo do Restaurante (Clique para personalizar a logo)"}
		>
			{#if storeLogo}
				<img src={storeLogo} alt={storeName || "Logo da Loja"} class="brand-avatar-img custom-logo-img" />
			{:else}
				<img src="./brand/matafome_icon_dark.png" alt="MataFome" class="brand-avatar-img default-mascot-img" />
			{/if}
		</div>

		<div class="brand-text-box">
			<div class="brand-name store-brand-name" title={storeName || "Meu Restaurante"}>
				{storeName ? storeName : "MataFome Gourmet"}
			</div>
			<div class="brand-status-row">
				<span class="status-live-dot"></span>
				<span class="brand-status-text">Operação Ativa</span>
			</div>
		</div>
	</div>

	<!-- 2. Lista de Navegação Principal -->
	<nav class="sidebar-nav">
		<!-- ZONA 1 — OPERAÇÃO -->
		<div class="nav-section">
			<div class="nav-section-header">
				<span class="nav-section-title">Operação</span>
			</div>
			<div class="nav-section-items">
				<!-- Início / Kanban -->
				<button
					type="button"
					class="nav-item {activeTab === 'kanban' ? 'active' : ''} {!isAuthenticated || !isSubscriptionActive ? 'locked' : ''} {!isTabAllowed('kanban', currentUser?.role) ? 'role-blocked' : ''}"
					on:click={() => select("kanban")}
					title={!isTabAllowed('kanban', currentUser?.role) ? 'Módulo liberado para Dono e Caixa' : 'Painel de Pedidos'}
				>
					<div class="item-icon">
						<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
							<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
							<polyline points="9 22 9 12 15 12 15 22"></polyline>
						</svg>
					</div>
					<span class="item-label">Pedidos</span>
					{#if activeOrdersCount > 0 && isAuthenticated && isSubscriptionActive && isTabAllowed('kanban', currentUser?.role)}
						<span class="badge-pill-count">{activeOrdersCount}</span>
					{/if}
				</button>

				<!-- Mesas & Salão -->
				<button
					type="button"
					class="nav-item {activeTab === 'tables' ? 'active' : ''} {!isAuthenticated || !isSubscriptionActive ? 'locked' : ''}"
					on:click={() => select("tables")}
					title="Mesas do Salão & Comandas"
				>
					<div class="item-icon">
						<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
							<rect x="3" y="4" width="18" height="12" rx="2"></rect>
							<line x1="6" y1="20" x2="6" y2="16"></line>
							<line x1="18" y1="20" x2="18" y2="16"></line>
						</svg>
					</div>
					<span class="item-label">Mesas</span>
				</button>

				<!-- Entregadores & Roleta de Motoboys -->
				<button
					type="button"
					class="nav-item {activeTab === 'couriers' ? 'active' : ''} {!isAuthenticated || !isSubscriptionActive ? 'locked' : ''} {!isTabAllowed('couriers', currentUser?.role) ? 'role-blocked' : ''}"
					on:click={() => select("couriers")}
					title={!isTabAllowed('couriers', currentUser?.role) ? 'Módulo liberado para Dono e Caixa' : 'Roleta de Motoboys & Acerto'}
				>
					<div class="item-icon">
						<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
							<circle cx="18.5" cy="17.5" r="3.5"></circle>
							<circle cx="5.5" cy="17.5" r="3.5"></circle>
							<circle cx="15" cy="5" r="1"></circle>
							<path d="M12 17.5V14l-3-3 4-3 2 3h2"></path>
						</svg>
					</div>
					<span class="item-label">Entregadores</span>
				</button>

				<!-- Controle de Caixa (Operacional) -->
				<button
					type="button"
					class="nav-item {activeTab === 'cashier' ? 'active' : ''} {!isAuthenticated || !isSubscriptionActive ? 'locked' : ''} {!isTabAllowed('cashier', currentUser?.role) ? 'role-blocked' : ''}"
					on:click={() => select("cashier")}
					title={!isTabAllowed('cashier', currentUser?.role) ? 'Módulo liberado para Dono e Caixa' : 'Controle de Caixa & Turnos'}
				>
					<div class="item-icon">
						<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
							<rect x="2" y="4" width="20" height="16" rx="2"></rect>
							<line x1="12" y1="8" x2="12" y2="16"></line>
							<line x1="8" y1="12" x2="16" y2="12"></line>
						</svg>
					</div>
					<span class="item-label">Caixa</span>
				</button>
			</div>
		</div>

		<!-- ZONA 2 — VENDAS & IA -->
		<div class="nav-section">
			<div class="nav-section-header">
				<span class="nav-section-title">Vendas & IA</span>
			</div>
			<div class="nav-section-items">
				<!-- WhatsApp / Atendimento -->
				<button
					type="button"
					class="nav-item {activeTab === 'whatsapp' ? 'active' : ''} {!isAuthenticated || !isSubscriptionActive ? 'locked' : ''} {!isTabAllowed('whatsapp', currentUser?.role) ? 'role-blocked' : ''}"
					on:click={() => select("whatsapp")}
					title={!isTabAllowed('whatsapp', currentUser?.role) ? 'Disponível exclusivamente para o Dono' : 'Central WhatsApp'}
				>
					<div class="item-icon">
						<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
							<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
							<circle cx="9" cy="10" r="1" fill="currentColor"></circle>
							<circle cx="12" cy="10" r="1" fill="currentColor"></circle>
							<circle cx="15" cy="10" r="1" fill="currentColor"></circle>
						</svg>
					</div>
					<span class="item-label">WhatsApp IA</span>
				</button>

				<!-- Funil do Agente -->
				<button
					type="button"
					class="nav-item {activeTab === 'agent_funnel' ? 'active' : ''} {!isAuthenticated || !isSubscriptionActive ? 'locked' : ''} {!isTabAllowed('agent_funnel', currentUser?.role) ? 'role-blocked' : ''}"
					on:click={() => select("agent_funnel")}
					title={!isTabAllowed('agent_funnel', currentUser?.role) ? 'Disponível exclusivamente para o Dono' : 'Estratégia & Funil de Vendas do Agente IA'}
				>
					<div class="item-icon">
						<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
							<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
						</svg>
					</div>
					<span class="item-label">Funil de Vendas</span>
				</button>

				<!-- Cupons & Fidelidade -->
				<button
					type="button"
					class="nav-item {activeTab === 'loyalty' ? 'active' : ''} {!isAuthenticated || !isSubscriptionActive ? 'locked' : ''} {!isTabAllowed('loyalty', currentUser?.role) ? 'role-blocked' : ''}"
					on:click={() => select("loyalty")}
					title={!isTabAllowed('loyalty', currentUser?.role) ? 'Disponível exclusivamente para o Dono' : 'Programa Fidelidade & Cupons'}
				>
					<div class="item-icon">
						<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
							<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
							<line x1="7" y1="7" x2="7.01" y2="7"></line>
						</svg>
					</div>
					<span class="item-label">Fidelidade</span>
				</button>
			</div>
		</div>

		<!-- ZONA 3 — GESTÃO -->
		<div class="nav-section">
			<div class="nav-section-header">
				<span class="nav-section-title">Gestão</span>
			</div>
			<div class="nav-section-items">
				<!-- Cardápio -->
				<button
					type="button"
					class="nav-item {activeTab === 'menu' ? 'active' : ''} {!isAuthenticated || !isSubscriptionActive ? 'locked' : ''} {!isTabAllowed('menu', currentUser?.role) ? 'role-blocked' : ''}"
					on:click={() => select("menu")}
					title={!isTabAllowed('menu', currentUser?.role) ? 'Disponível exclusivamente para o Dono' : 'Gestão do Cardápio'}
				>
					<div class="item-icon">
						<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
							<path d="M18 2v20"></path>
							<path d="M21 2c0 3.31-1.34 6-3 6s-3-2.69-3-6"></path>
							<path d="M3 2v8c0 1.66 1.34 3 3 3s3-1.34 3-3V2"></path>
							<path d="M6 13v9"></path>
							<line x1="6" y1="2" x2="6" y2="6"></line>
						</svg>
					</div>
					<span class="item-label">Cardápio</span>
				</button>

				<!-- Financeiro & DRE (Exclusivo do Dono) -->
				<button
					type="button"
					class="nav-item {activeTab === 'reports' ? 'active' : ''} {!isAuthenticated || !isSubscriptionActive ? 'locked' : ''} {!isTabAllowed('reports', currentUser?.role) ? 'role-blocked' : ''}"
					on:click={() => select("reports")}
					title={!isTabAllowed('reports', currentUser?.role) ? 'Disponível exclusivamente para o Dono' : 'Financeiro Gerencial'}
				>
					<div class="item-icon">
						<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
							<line x1="18" y1="20" x2="18" y2="10"></line>
							<line x1="12" y1="20" x2="12" y2="4"></line>
							<line x1="6" y1="20" x2="6" y2="14"></line>
						</svg>
					</div>
					<span class="item-label">Financeiro</span>
				</button>

				<!-- Impressão Térmica -->
				<button
					type="button"
					class="nav-item {activeTab === 'printer' ? 'active' : ''} {!isAuthenticated || !isSubscriptionActive ? 'locked' : ''} {!isTabAllowed('printer', currentUser?.role) ? 'role-blocked' : ''}"
					on:click={() => select("printer")}
					title={!isTabAllowed('printer', currentUser?.role) ? 'Módulo liberado para Dono e Caixa' : 'Impressora de Comandas'}
				>
					<div class="item-icon">
						<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
							<polyline points="6 9 6 2 18 2 18 9"></polyline>
							<path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
							<rect x="6" y="14" width="12" height="8"></rect>
						</svg>
					</div>
					<span class="item-label">Impressão</span>
				</button>

				<!-- Configurações -->
				<button
					type="button"
					class="nav-item {activeTab === 'settings' ? 'active' : ''} {!isTabAllowed('settings', currentUser?.role) ? 'role-blocked' : ''}"
					on:click={() => select("settings")}
					title={!isTabAllowed('settings', currentUser?.role) ? 'Disponível exclusivamente para o Dono' : 'Configurações da Loja'}
				>
					<div class="item-icon">
						<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
							<circle cx="12" cy="12" r="3"></circle>
							<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
						</svg>
					</div>
					<span class="item-label">Configurações</span>
				</button>
			</div>
		</div>
	</nav>

	<!-- 3. Status de Conexão Discreto na Sidebar -->
	<div class="sidebar-status-bar">
		<div class="status-pill" title="WhatsApp: {whatsappStatus}">
			<span class="status-dot {whatsappStatus === 'Conectado' ? 'green' : 'amber'}"></span>
			<span class="status-label">WhatsApp</span>
		</div>
		<div class="status-pill" title="Impressora: {printerStatus}">
			<span class="status-dot {printerStatus.toLowerCase().includes('online') || printerStatus.toLowerCase().includes('pronta') ? 'green' : 'amber'}"></span>
			<span class="status-label">Impressora</span>
		</div>
	</div>

	<!-- 4. Card do Perfil do Lojista (Moderno, com Foto & Menu Popover) -->
	<div class="profile-card-wrapper">
		<!-- Popover Flutuante Elegante -->
		{#if showProfileMenu}
			<div class="profile-popover-menu" on:click|stopPropagation>
				<div class="popover-user-header">
					<div class="popover-avatar-box">
						{#if userAvatar}
							<img src={userAvatar} alt="Foto de Perfil" class="popover-avatar-img" />
						{:else}
							<span class="popover-avatar-letter">{(currentUser?.name || storeName || 'U')[0].toUpperCase()}</span>
						{/if}
					</div>
					<div class="popover-user-meta">
						<div class="popover-user-name">{currentUser?.name || 'Operador'}</div>
						<div class="popover-store-name">{storeName || 'MataFome'}</div>
					</div>
				</div>

				<div class="popover-actions-list">
					<!-- Upload de Foto de Perfil -->
					<button type="button" class="popover-action-btn" on:click={triggerAvatarUpload}>
						<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
							<circle cx="12" cy="13" r="4"></circle>
						</svg>
						<span>{userAvatar ? 'Alterar foto de perfil' : 'Adicionar foto de perfil'}</span>
					</button>
					{#if userAvatar}
						<button type="button" class="popover-action-btn danger-text" on:click={removeAvatar}>
							<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<line x1="18" y1="6" x2="6" y2="18"></line>
								<line x1="6" y1="6" x2="18" y2="18"></line>
							</svg>
							<span>Remover foto</span>
						</button>
					{/if}

					<div class="popover-divider"></div>

					<!-- Trocar Operador -->
					<button type="button" class="popover-action-btn" on:click={() => { showProfileMenu = false; onOpenSwitchUser(); }}>
						<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
							<circle cx="9" cy="7" r="4"></circle>
							<polyline points="16 11 18 13 22 9"></polyline>
						</svg>
						<span>Alternar Operador (PIN)</span>
					</button>

					<!-- Configurações da Loja -->
					<button type="button" class="popover-action-btn" on:click={() => { showProfileMenu = false; select('settings'); }}>
						<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<circle cx="12" cy="12" r="3"></circle>
							<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
						</svg>
						<span>Configurações da Loja</span>
					</button>

					<!-- Personalizar Logo da Loja -->
					<button type="button" class="popover-action-btn" on:click={() => { showProfileMenu = false; triggerStoreLogoUpload(); }}>
						<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
							<circle cx="8.5" cy="8.5" r="1.5"></circle>
							<polyline points="21 15 16 10 5 21"></polyline>
						</svg>
						<span>{storeLogo ? 'Alterar Logo da Loja' : 'Personalizar Logo da Loja'}</span>
					</button>

					{#if storeLogo}
						<button type="button" class="popover-action-btn danger-text" on:click={() => { showProfileMenu = false; restoreDefaultStoreLogo(); }}>
							<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
								<path d="M3 3v5h5"/>
							</svg>
							<span>Restaurar Padrão MataFome</span>
						</button>
					{/if}

					<!-- Portal Master SaaS (Apenas Proprietário) -->
					{#if currentUser?.role === 'owner'}
						<button type="button" class="popover-action-btn" on:click={() => { showProfileMenu = false; select('master'); }}>
							<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
							</svg>
							<span>Portal Master SaaS</span>
						</button>
					{/if}

					<div class="popover-divider"></div>

					<!-- Encerrar Sessão -->
					<button type="button" class="popover-action-btn danger" on:click={() => { showProfileMenu = false; select('logout'); }}>
						<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
							<polyline points="16 17 21 12 16 7"></polyline>
							<line x1="21" y1="12" x2="9" y2="12"></line>
						</svg>
						<span>Sair da Conta</span>
					</button>
				</div>
			</div>
		{/if}

		<input type="file" accept="image/*" style="display:none;" bind:this={fileInputRef} on:change={handleAvatarUpload} />

		<!-- Card Visível do Usuário -->
		<div 
			class="profile-card {showProfileMenu ? 'active' : ''}" 
			on:click|stopPropagation={() => showProfileMenu = !showProfileMenu}
			title="Clique para gerenciar perfil ou trocar operador"
		>
			<div class="profile-avatar">
				{#if userAvatar}
					<img src={userAvatar} alt="Foto" class="avatar-photo" />
				{:else}
					<span class="avatar-letter">{(currentUser?.name || storeName || 'U')[0].toUpperCase()}</span>
				{/if}
				<span class="online-indicator"></span>
			</div>
			<div class="profile-info">
				<div class="profile-name">{currentUser?.name || storeName || 'Operador'}</div>
				<div class="profile-role-badge {currentUser?.role || 'owner'}">
					{#if currentUser?.role === 'waiter'}
						Garçom
					{:else if currentUser?.role === 'cashier'}
						Caixa
					{:else}
						Dono
					{/if}
				</div>
			</div>
			<div class="profile-caret">
				<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
					<polyline points="18 15 12 9 6 15"></polyline>
				</svg>
			</div>
		</div>
	</div>
</aside>

<style>
	.sidebar {
		width: 236px;
		background: #0F1218;
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 14px 12px 14px 12px;
		border-right: 1px solid rgba(255, 255, 255, 0.07);
		z-index: 50;
		flex-shrink: 0;
		box-sizing: border-box;
		user-select: none;
	}

	/* Marca / Header da Sidebar */
	.brand-box {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 6px 8px 14px 8px;
		cursor: pointer;
		border-bottom: 1px solid rgba(255, 255, 255, 0.08);
		margin-bottom: 12px;
		transition: all 0.2s ease;
		border-radius: 10px;
	}

	.brand-box:hover {
		background: rgba(255, 255, 255, 0.03);
	}

	.brand-avatar-box {
		width: 56px;
		height: 56px;
		background: transparent;
		border-radius: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		border: none;
		box-shadow: none;
		flex-shrink: 0;
		position: relative;
		overflow: visible;
		transition: all 0.2s ease;
		cursor: pointer;
	}

	.brand-avatar-box:hover {
		transform: scale(1.05);
	}

	.brand-avatar-box.has-custom-logo {
		border: none;
		background: transparent;
	}

	.brand-avatar-img.custom-logo-img {
		width: 100%;
		height: 100%;
		object-fit: contain;
		border-radius: 0;
		filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.35));
	}

	.brand-avatar-img.default-mascot-img {
		width: 100%;
		height: 100%;
		object-fit: contain;
		border-radius: 0;
	}

	.brand-text-box {
		display: flex;
		flex-direction: column;
		justify-content: center;
		min-width: 0;
		flex: 1;
	}

	.store-brand-name {
		font-size: 14px;
		font-weight: 700;
		color: #FFFFFF;
		line-height: 1.25;
		letter-spacing: -0.2px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		max-width: 155px;
		word-break: break-word;
	}

	.brand-status-row {
		display: flex;
		align-items: center;
		gap: 6px;
		margin-top: 3px;
	}

	.status-live-dot {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: #10B981;
		box-shadow: 0 0 8px rgba(16, 185, 129, 0.8);
		display: inline-block;
		flex-shrink: 0;
	}

	.brand-status-text {
		font-size: 11px;
		font-weight: 600;
		color: #94A3B8;
		letter-spacing: 0.1px;
	}

	/* Navegação Principal em Zonas Semânticas */
	.sidebar-nav {
		display: flex;
		flex-direction: column;
		gap: 10px;
		flex: 1;
		overflow-y: auto;
		overflow-x: hidden;
		padding-right: 2px;
	}

	.sidebar-nav::-webkit-scrollbar {
		width: 4px;
	}

	.sidebar-nav::-webkit-scrollbar-thumb {
		background: rgba(255, 255, 255, 0.1);
		border-radius: 4px;
	}

	.nav-section {
		display: flex;
		flex-direction: column;
		gap: 2px;
	}

	.nav-section-header {
		padding: 4px 8px 3px 8px;
	}

	.nav-section-title {
		font-size: 9.5px;
		font-weight: 600;
		color: #64748B;
		text-transform: uppercase;
		letter-spacing: 0.6px;
	}

	.nav-section-items {
		display: flex;
		flex-direction: column;
		gap: 2px;
	}

	.nav-item {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 8px 10px;
		border-radius: var(--radius-sm, 6px);
		color: #94A3B8;
		background: transparent;
		border: 1px solid transparent;
		border-left: 3px solid transparent;
		cursor: pointer;
		font-family: inherit;
		font-size: 12.5px;
		font-weight: 500;
		text-align: left;
		transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
		position: relative;
	}

	.nav-item:hover {
		background: rgba(255, 255, 255, 0.05);
		color: #FFFFFF;
	}

	.nav-item.active {
		background: rgba(255, 106, 0, 0.12);
		color: #FFFFFF;
		font-weight: 600;
		border-color: rgba(255, 106, 0, 0.25);
		border-left: 3px solid #FF6A00;
	}

	.nav-item.active .item-icon {
		color: #FF6A00;
	}

	.nav-item.locked {
		opacity: 0.35;
		cursor: not-allowed;
	}

	.nav-item.role-blocked {
		display: none;
	}

	.item-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		transition: color 0.15s ease;
	}

	.item-label {
		flex: 1;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.badge-pill-count {
		background: rgba(255, 106, 0, 0.16);
		color: #FF8A3D;
		border: 1px solid rgba(255, 106, 0, 0.3);
		font-size: 10.5px;
		font-weight: 700;
		padding: 1px 6px;
		border-radius: 9999px;
		line-height: 1.2;
	}

	.badge-pill-count.red {
		background: rgba(239, 68, 68, 0.16);
		color: #F87171;
		border-color: rgba(239, 68, 68, 0.3);
	}

	.nav-item.active .badge-pill-count {
		background: #FF6A00;
		color: #FFFFFF;
		border-color: transparent;
	}

	.nav-item.active .badge-pill-count.red {
		background: #DC2626;
		color: #FFFFFF;
		border-color: transparent;
	}

	/* Status Bar Discreto */
	.sidebar-status-bar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 7px 10px;
		background: rgba(255, 255, 255, 0.03);
		border: 1px solid rgba(255, 255, 255, 0.06);
		border-radius: var(--radius-sm, 6px);
		margin-bottom: 10px;
		font-size: 11px;
	}

	.status-pill {
		display: flex;
		align-items: center;
		gap: 6px;
		color: #94A3B8;
	}

	.status-dot {
		width: 6px;
		height: 6px;
		border-radius: 50%;
	}

	.status-dot.green {
		background: #10B981;
		box-shadow: 0 0 6px rgba(16, 185, 129, 0.6);
	}

	.status-dot.amber {
		background: #64748B;
	}

	.status-label {
		font-weight: 500;
		font-size: 10.5px;
	}

	/* Wrapper do Perfil do Usuário */
	.profile-card-wrapper {
		position: relative;
	}

	.profile-card {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 7px 10px;
		background: #141820;
		border: 1px solid rgba(255, 255, 255, 0.07);
		border-radius: var(--radius-md, 10px);
		cursor: pointer;
		transition: all 0.15s ease;
	}

	.profile-card:hover, .profile-card.active {
		background: #19202B;
		border-color: rgba(255, 106, 0, 0.3);
	}

	.profile-avatar {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		background: #202734;
		border: 1.5px solid rgba(255, 255, 255, 0.12);
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		flex-shrink: 0;
		overflow: hidden;
	}

	.avatar-photo {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.avatar-letter {
		color: #FF6A00;
		font-weight: 700;
		font-size: 13px;
	}

	.online-indicator {
		position: absolute;
		bottom: 0;
		right: 0;
		width: 7px;
		height: 7px;
		background: #10B981;
		border-radius: 50%;
		border: 1.5px solid #0F1218;
	}

	.profile-info {
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		gap: 2px;
	}

	.profile-name {
		font-size: 11.5px;
		font-weight: 600;
		color: #FFFFFF;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.profile-role-badge {
		font-size: 9px;
		font-weight: 600;
		text-transform: uppercase;
		letter-spacing: 0.4px;
		padding: 1px 5px;
		border-radius: 4px;
		display: inline-block;
		width: fit-content;
	}

	.profile-role-badge.owner {
		background: rgba(255, 106, 0, 0.15);
		color: #FF8A33;
		border: 1px solid rgba(255, 106, 0, 0.25);
	}

	.profile-role-badge.cashier {
		background: rgba(34, 197, 94, 0.15);
		color: #4ADE80;
		border: 1px solid rgba(34, 197, 94, 0.25);
	}

	.profile-role-badge.waiter {
		background: rgba(59, 130, 246, 0.15);
		color: #60A5FA;
		border: 1px solid rgba(59, 130, 246, 0.25);
	}

	.profile-caret {
		color: #64748B;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: transform 0.15s ease;
	}

	.profile-card.active .profile-caret {
		transform: rotate(180deg);
		color: #FF6A00;
	}

	/* Popover Flutuante de Perfil (Abre para cima) */
	.profile-popover-menu {
		position: absolute;
		bottom: calc(100% + 8px);
		left: 0;
		right: 0;
		background: #181D26;
		border: 1px solid rgba(255, 255, 255, 0.12);
		border-radius: var(--radius-md, 10px);
		box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.35);
		padding: 8px;
		z-index: 100;
		animation: popoverFadeIn 0.15s ease;
	}

	@keyframes popoverFadeIn {
		from { opacity: 0; transform: translateY(6px); }
		to { opacity: 1; transform: translateY(0); }
	}

	.popover-user-header {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 6px 8px 10px 8px;
		border-bottom: 1px solid rgba(255, 255, 255, 0.07);
		margin-bottom: 6px;
	}

	.popover-avatar-box {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		background: #232B38;
		border: 1px solid rgba(255, 106, 0, 0.3);
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		flex-shrink: 0;
	}

	.popover-avatar-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.popover-avatar-letter {
		font-weight: 700;
		color: #FF6A00;
		font-size: 13px;
	}

	.popover-user-meta {
		display: flex;
		flex-direction: column;
		min-width: 0;
	}

	.popover-user-name {
		font-size: 12px;
		font-weight: 600;
		color: #FFFFFF;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.popover-store-name {
		font-size: 10px;
		color: #94A3B8;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.popover-actions-list {
		display: flex;
		flex-direction: column;
		gap: 2px;
	}

	.popover-action-btn {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 7px 10px;
		border-radius: var(--radius-sm, 6px);
		background: transparent;
		border: none;
		color: #CBD5E1;
		font-size: 12px;
		font-weight: 500;
		cursor: pointer;
		width: 100%;
		text-align: left;
		transition: all 0.12s ease;
	}

	.popover-action-btn:hover {
		background: rgba(255, 255, 255, 0.08);
		color: #FFFFFF;
	}

	.popover-action-btn.danger-text {
		color: #EF4444;
	}

	.popover-action-btn.danger:hover {
		background: rgba(239, 68, 68, 0.15);
		color: #EF4444;
	}

	.popover-divider {
		height: 1px;
		background: rgba(255, 255, 255, 0.07);
		margin: 4px 0;
	}

	/* ========================================================
	   RESPONSIVIDADE: TABLET (768px - 1023px) — MODO COMPACTO (68px)
	   ======================================================== */
	@media (min-width: 768px) and (max-width: 1023px) {
		.sidebar {
			width: 68px;
			padding: 14px 8px 14px 8px;
			align-items: center;
		}

		.brand-box {
			padding: 4px 0 12px 0;
			justify-content: center;
			margin-bottom: 8px;
			width: 100%;
		}

		.brand-text-box {
			display: none;
		}

		.nav-section {
			width: 100%;
			border-bottom: 1px solid rgba(255, 255, 255, 0.05);
			padding-bottom: 6px;
			margin-bottom: 6px;
		}

		.nav-section:last-child {
			border-bottom: none;
			padding-bottom: 0;
			margin-bottom: 0;
		}

		.nav-section-header {
			display: none;
		}

		.nav-section-items {
			width: 100%;
			align-items: center;
		}

		.nav-item {
			justify-content: center;
			padding: 9px 0;
			position: relative;
			width: 100%;
			border-left: 1px solid transparent;
		}

		.nav-item.active {
			border-left: 1px solid rgba(255, 106, 0, 0.3);
		}

		.item-label {
			display: none;
		}

		.badge-pill-count {
			position: absolute;
			top: 3px;
			right: 4px;
			padding: 1px 4px;
			font-size: 9.5px;
		}

		.sidebar-status-bar {
			padding: 6px 0;
			flex-direction: column;
			gap: 6px;
			align-items: center;
			width: 100%;
		}

		.status-label {
			display: none;
		}

		.status-pill {
			padding: 3px;
			justify-content: center;
			width: auto;
		}

		.profile-card-wrapper {
			padding: 0;
			display: flex;
			justify-content: center;
			width: 100%;
		}

		.profile-info,
		.profile-caret {
			display: none;
		}

		.profile-card {
			padding: 4px;
			justify-content: center;
		}
	}

	/* ========================================================
	   RESPONSIVIDADE: MOBILE (< 768px) — DRAWER OFF-CANVAS
	   ======================================================== */
	@media (max-width: 767px) {
		.sidebar {
			position: fixed;
			top: 0;
			left: 0;
			bottom: 0;
			height: 100%;
			height: 100dvh;
			width: 260px;
			max-width: 82vw;
			z-index: 9999;
			transform: translateX(-100%);
			box-shadow: none;
			transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);
		}

		.sidebar.mobile-open {
			transform: translateX(0);
			box-shadow: 0 0 30px rgba(0, 0, 0, 0.7);
		}

		.sidebar-backdrop {
			position: fixed;
			inset: 0;
			background: rgba(11, 14, 20, 0.7);
			backdrop-filter: blur(4px);
			z-index: 9998;
			animation: fadeInBackdrop 0.2s ease-out;
		}

		@keyframes fadeInBackdrop {
			from { opacity: 0; }
			to { opacity: 1; }
		}
	}
</style>
